'use client'

import api from "@/util/api"
import { MutableRefObject, useContext, useEffect, useRef, useState } from "react"
import Lottie from "react-lottie-player"
import loadingJson from "@/public/media/load_data.json"
import PageTabType2, { PageTabType } from "@/components/etc/pageTabType2"
import { useRouter } from "next/navigation"
import SectionTitle from "@/components/etc/section_title"
import { DeviceContext } from "@/context/deviceContext"
import SectionTab from "@/components/etc/section_tab"
import { useLocale, useTranslations } from "next-intl"

interface Props {
    type?: string;
    
    setshowSpots?: React.Dispatch<React.SetStateAction<boolean>>;
    setshowScore?: React.Dispatch<React.SetStateAction<boolean>>;
    showSpots?:boolean,
    showScore?:boolean,
    positionTopRef?: MutableRefObject<boolean>;
    setPositionTopFlag?: (value: boolean) => void;
}
export default function LiveSpotsComponent({type, setshowSpots, setshowScore, showSpots, showScore, positionTopRef, setPositionTopFlag}:Props){

    const { mobileMode } = useContext(DeviceContext)
    const locale = useLocale();
    const host = window.location.protocol + "//" + window.location.hostname + (process.env.NODE_ENV === "development" ? ":8000" : "")
    // const host = window.location.protocol + "//" + window.location.hostname + ":8000"
    const [iframePath, setiFramePath] = useState<string | undefined>(`${host}/event`); 
    const [iframePath2, setiFramePath2] = useState<string | undefined>(`${host}/event`); 

    const [pageTab, setPageTab] = useState<PageTabType[]>([])
    const [pageSubTab, setPageSubTab] = useState<PageTabType[]>([])
    
    const [loading, setLoading] = useState<boolean>(true)
    const router = useRouter()
    const [loadFrame, setLoadFrame] = useState<boolean>(false)

    const [iframeKey, setIframeKey] = useState(String(Date.now()));

    /**
     * ●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●
     * 
     *    프록시 막히면 아래값만 true로 변경하고 배포하세여
     *      페이지 준비중 이미지 띄워놨습니다.
     * 
     * ●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●
     */
    const [isWating, setIsWating] = useState<boolean>(false)

    

    function fetchData() {

        setLoading(true)


        // const apiUrl = `/api/iframe/score/` + (type ?`?type=${type}`:"")
        const apiUrl = `/api/iframe/sports/` 
        api(apiUrl)
            .then(res => res.json())
            .then(({ data }) => {
                const objects = data?.objects ?? [];


                /* ********************************* */
                const subTabs: PageTabType[] = Object.entries(objects).flatMap(
                    ([sport, leagues], sportIdx) =>
                        (leagues as any[]).map((item) => ({
                            id: item.id, 
                            title: item.league_display,
                            url: item.url,
                            parentId: sportIdx + 1 
                        })
                    )
                );
                setPageSubTab(subTabs);
                
                const topTabs: PageTabType[] = Object.entries(objects).map(
                    ([sport, leagues], idx) => {
                        const firstLeague = (leagues as any[])[0]; // 서브탭 첫 번째
                        return {
                        id: idx + 1,
                        title: sport,
                        sports_type_label: firstLeague ? firstLeague.sports_type_label : ""
                        };
                    }
                );
                setPageTab(topTabs);
                /* ********************************* */

                
                // setiFramePath(`${host}${data.objects['축구'][0].url}`)
                setLoading(false)

            })
            .catch(err => {
                console.error("fetchData error:", err);
                setLoading(false)
            });
    }
    
    function setOpenView(_parent:any){
        const firstSubTab = pageSubTab.find((sub) => sub.parentId === _parent.id);
        if (firstSubTab) {
            setiFramePath(host + firstSubTab.url);
        }
    }

    function clickMainTab(id:number, obj:any){ 
        setOpenView(obj)
    }

    const handleMain = (id: number, obj: PageTabType) => {
        // console.log("메인 탭 클릭:", id, obj);
    }; 

    const handleSub = (id: number, obj: PageTabType) => {
        // console.log("서브 탭 클릭:", id, obj.url);
        setLoading(true)
        // setiFramePath(host + obj.url)
        
        if(iframePath != (host + obj.url)) {
            setiFramePath("")
            setTimeout(() => {
                setiFramePath(host + obj.url)
            }, 100);
        }else{
            setLoading(false)
        }

        
    };
    useEffect(()=> {
        if(!isWating){
            setLoading(true)
            fetchData()
        }else{
            setLoading(false)
        }
    }, [])  

    const boxRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (!iframePath) return;
        setIframeKey(String(Date.now()));
        setiFramePath2(iframePath)
    },[iframePath]);

    useEffect(() => {
        function handleMessage(event: MessageEvent) {
            if (event.data?.type === "height") {
                // console.log("***height sports ", event.data);

                const iframes = document.querySelectorAll<HTMLIFrameElement>(".sp-ifram");
                iframes.forEach((iframe) => {
                    // src 매칭해서 해당 프레임만 높이 조정
                    if (iframe.src === event.data.target) {
                    iframe.style.height = event.data.height + "px";
                    }
                });
            }
        }

        window.addEventListener("message", handleMessage);

        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, [iframePath2]);




    

    function afterLoadIframe(){
        // console.log("여기2", positionTopRef?.current);
        if(type && positionTopRef?.current){
            setTimeout(() => {
                const wrapper = document.querySelector('.iframeStickyWrapper');
                if (wrapper) {
                    const rect = wrapper.getBoundingClientRect();
                    const wrapperTop = rect.top + window.scrollY;
                    const HEADER_HEIGHT = 50;
                    window.scrollTo({
                        top: wrapperTop - HEADER_HEIGHT
                    });
                }
            }, 100);
        }
        setLoading(false);
        setLoadFrame(prev => !prev); 
        setTimeout(() => {
            setPositionTopFlag?.(false)
        }, 200);
    }

    const t = useTranslations('PageTitle')



    return (
        <>
        
            {type ? 
            <>
            <div ref={boxRef} 
                className={`${mobileMode?"stickyBox":""}`}>
                <SectionTab setshowSpots={setshowSpots} 
                            setshowScore={setshowScore} 
                            showSpots={showSpots} 
                            showScore={showScore}
                            setpositionTop={setPositionTopFlag}></SectionTab>
                <SectionTitle shortCut={`/livesports/`} type="sports" className={`p-b-8`}>{t.rich('스포츠 b:팀순위', { b: (chunks) => <b>{chunks}</b> })}</SectionTitle>
                <PageTabType2
                    mainTab={pageTab}
                    subTab={pageSubTab}
                    clickMainTab={handleMain}
                    clickSubTab={handleSub}
                    setLoading={setLoading}
                    type={type}
                    loadFrame={loadFrame}
                    setLoadFrame={setLoadFrame}  />
            </div>
            </>
            :
            
            <PageTabType2
                mainTab={pageTab}
                subTab={pageSubTab}
                clickMainTab={handleMain}
                clickSubTab={handleSub}
                setLoading={setLoading}
                type={type}
                loadFrame={loadFrame}
                setLoadFrame={setLoadFrame}  />
            }

            

            <div className={`loadingWrapper`}>

                {isWating ? 
                    <div className={`flex center`}>
                        <img src={`/image/etc/ready_${locale}.png`} />
                    </div>
                    :
                
                    <iframe src={`${iframePath2}`} 
                            width={`100%`} 
                            className={`sp-ifram`}
                            key={iframeKey}
                            onLoad={(e)=>{
                                afterLoadIframe()
                                // setLoading(false);
                                // setLoadFrame(prev => !prev); 
                            }}
                            style={{minHeight:`300px`, border:"0"}}
                            data-type={type || "full"}></iframe>
                }
                <div className={`loadingObj ${loading ? "show" : ""}`}>
                    <Lottie loop animationData={loadingJson} play style={{ maxWidth: "400px", margin: "0 auto" }} />
                </div>
            </div>


        </> 
    )


}
